import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    background: ({color}) =>
      color === 'transparent'
        ? 'transparent' :
      color === 'success'
        ? theme.custom.button.success :
      color === 'danger'
        ? theme.custom.button.danger :
      color === 'warning'
        ? theme.custom.button.warning
        : theme.custom.button.primary,
    border: ({color}) => color === 'transparent' ? '2px solid' : 0,
    borderRadius: 5,
    color: ({color}) => color === 'transparent' ? theme.custom.button.transparentColor : theme.custom.button.contrast,
    height: 45,
    padding: '0 25px',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '110%'
  },
}));

const DefaultButton = (props) => {
  const {color, className, ...other} = props;
  const classes = useStyles(props);
  return <Button className={`${classes.root} ${className}`} {...other} />;
};

DefaultButton.propTypes = {
  color: PropTypes.oneOf(['primary', 'danger', 'warning', 'success', 'transparent']).isRequired,
};

export default DefaultButton;